<template>
  <div class="home">
    <div class="left">
      <Content :html="body" />
    </div>
    <div class="right">
      <div class="sections">
        <Section class="section" :section="section" v-for="section in sections" />
      </div>
      <div class="members">
        <Ambassadors name="AMBASSADORS" url="/ambassadors-allies#s1" :items="advisors" v-if="advisors" />
        <Partners name="ALLIES" url="/ambassadors-allies#s2" :items="partners" v-if="partners" />
      </div> 
    </div>
  </div>
</template>

<script>
import ApiClient from '../api/index'
import { SET_COLOR_SIDEBAR } from '../store'
import Content from '../components/Content.vue'
import Section from '../components/Section.vue'
import Carousel from '../components/Carousel.vue'
import completeLoad from '../mixins/completeLoad'
import Subscribe from '../components/Forms/Subscribe.vue'


import Ambassadors from '../components/Ambassadors.vue'
import Partners from '../components/Partners.vue'

export default {
  data () {
    return {
      body: null,
      forms: [],
      sections: [],
      advisors: false,
      partners: false,
    }
  },

  mixins: [completeLoad],

  components: {
    Content,
    Subscribe,
    Section,
    Carousel,
    Ambassadors,
    Partners
  },

  created () {
    this.$store.commit(SET_COLOR_SIDEBAR, null)
    this.toTop()
    this.fxLogo()
  },

  beforeCreate () {
    ApiClient.home()
    .then(response => {
      let page = response.data.page
      let sections = response.data.sections
      let advisors = response.data.advisors
      let partners = response.data.partners
      let title = response.data.title

      this.body = page.body
      this.forms = page.forms
      this.sections = sections
      this.advisors = advisors
      this.partners = partners
      document.title = page.title + ' | ' + drupalSettings.sitename
      this.completeLoad(page.background)
      this.setBodyClasses(['front-page'])
    })
  }
}
</script>

<style lang="scss">
.members {
  .ambassadors, .partners {
    height: 100%;
    width: 50%;
    @media screen and (max-width: 1019px) {
      width: 100%;
      height: auto;
    }
  }
}

.home {
  display: flex;
  align-items: center;
  height: 100%;
  .left, .right {
    width: calc(50% + 100px);
    height: 100%;
  }

  .right {
    border-left: 1px solid rgba(224, 224, 224, 0.5);
    border-right: 1px solid rgba(224, 224, 224, 0.5);
    width: calc(50% - 100px);
    .sections {
      height: 60%;
      border-bottom: 1px solid rgba(224, 224, 224, 0.5);
    }
    .ambassadors {
      border-right: 1px solid rgba(224, 224, 224, 0.5);
      margin-right: 1px; 
      @media screen and (max-width: 1019px) {
        border: 0px;
      }
    }
  }

  .text p {
    font-family: 'Montserrat', sans-serif;
    text-shadow: 1px 3px rgba(0, 0, 0, 0.35);
    color: white;
    font-size: 30px;
    line-height: 45px;

    @media only screen and (max-width: 1400px) {
      font-size: 22px;
      line-height: 35px;
    }
  }

  .sections {
    display: flex;
    .section {
      width: 50%;
      height: 100%;
      align-items: center;
      border-left: 1px solid rgba(224, 224, 224, 0.5);
      &:first-child {
        width: calc(50% - 1px);
        border: 0px;
      }
    }
  }
  .members {
    display: flex;
    height: 40%;
    @media screen and (max-width: 1019px) {
      display: block;
      height: auto;
    }
  }
}
</style>